import locale from "localization/en";

export const cashTransactionColumn = [
  { key: "product", text: locale.product },
  { key: "pumpNumber", text: locale.pumpNumber },
  { key: "quantity", text: locale.quantity },
  { key: "amount", text: locale.amount },
  {
    key: "discount",
    text: (
      <>
        {locale.discount} / {locale.premium}
      </>
    ),
  },
  { key: "finalAmountPaid", text: locale.finalAmountPaid },
];
